export const SOLO_AGENDA_RESOURCE = '__loop_company_agenda__';

export function calendarEmployeeId(value) {
  const id = String(value || '').trim();
  return id === '__unassigned__' || id === SOLO_AGENDA_RESOURCE ? '' : id;
}

// Visual resources belong to the calendar only, never to the underlying booking.
export function projectSoloCalendarEvent(event) {
  const raw = event?.extendedProps?.raw || event?.raw || event?.booking || {};
  const assigned = [event?.resourceId, ...(event?.resourceIds || []), event?.extendedProps?.resourceId,
    raw.employeeId, raw.workerId, raw.resourceId, raw.assignedEmployeeId,
    ...(raw.assignedEmployeeIds || [])].some(value => calendarEmployeeId(value));
  if (assigned) return event;
  return {...event, resourceId: SOLO_AGENDA_RESOURCE, resourceIds: [SOLO_AGENDA_RESOURCE],
    extendedProps: {...event?.extendedProps, resourceId: SOLO_AGENDA_RESOURCE}};
}
